<template lang="pug">
    include SchoolAdminCecs.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";
import FormMixin from "@/mixins/FormMixin";
import CecsMixin from "@/mixins/CecsMixin";

export default {
    name: 'SchoolAdminCecs',
    mixins: [FormMixin, CecsMixin,],
    data() {
        // Data contained on the component
        return {
            showNewForm: false,
            showEditForm: false,
            seed: null,
            cecs: [],
            uploadUrl: null,
            categoriesData: [],
            subcategoriesData: [],
            entity: {
                category: null,
                name: "",
                cecs: null,
                subcategories: [],
                facebook: "",
                linkedin: "",
                description: "",

                teaching_time: null,
                paced_activities: null,
                assesment: null,
                break_time: null,
                total_time: null,

                price: null,
                additional_information: "",
            }
        };
    },
    computed: {
        validNew() {
            if (!this.entity.subcategories.length) return false;
            if (!this.entity.name || !this.entity.name.length) return false;
            if (!this.entity.description || !this.entity.description.length) return false;
            return true;
        }
    },
    mounted() {
        this.$upload.reset('new-cec', {
            url: this.uploadUrl,
        });
    },
    beforeDestroy() {
        this.$upload.reset('new-cec', {
        });
    },
    created() {
        const _this = this;
        this.seed = this.$uuid.v4();
        let apiBase = Api.getApiUrl();
        this.uploadUrl = `${apiBase}/esreps/cec-update/?seed=${this.seed}&token=${this.$store.state.token}`;

        this.$upload.new('new-cec', {
            async: true,
            multiple: false,
        });

        this.fetchFormData((err, result) => {
            if (!err) {
                _this.categoriesData = result.categories;
                _this.subcategoriesData = result.subcategories;
            }
        });

        Api.me(this.$store.state.token).then(resp => {
            let availableCecs = _.reject(resp.data.cecs, item => {
                return (!item.name.length);
            });

            _this.cecs = availableCecs;
        }).catch();
    },
    methods: {
        isSubcategorySelected(item) {
            if (!this.entity.subcategories.length) return false;
            return (_.where(this.entity.subcategories, {pk: item.pk}).length);
        },
        edit(item) {
            this.editing = item;
            this.seed = item.seed;
            this.showEditForm = true;

            this.entity = {
                category: null,
                name: item.name,
                subcategories: [],
                facebook: item.facebook,
                linkedin: item.linkedin,
                description: item.description,

                cecs: null,
                teaching_time: null,
                paced_activities: null,
                assesment: null,
                break_time: null,
                total_time: null,

                price: null,
                additional_information: item.additional_information,
            };
        },
        resetView() {
            this.editing = null;
            this.showEditForm = false;
            this.showNewForm = false;
            this.seed = this.$uuid.v4();
            this.entity = {
                category: null,
                name: "",
                cecs: null,
                subcategories: [],
                facebook: "",
                linkedin: "",
                description: "",

                teaching_time: null,
                paced_activities: null,
                assesment: null,
                break_time: null,
                total_time: null,

                price: null,
                additional_information: "",
            };
        },
        saveNew() {
            // Preparing the data
            let postData = _.pick(this.entity, ...["name", "description", "additional_information"]);

            postData.cecs = this.pickNumber(this.entity.cecs);
            postData.teaching_time = this.pickNumber(this.entity.teaching_time);
            postData.paced_activities = this.pickNumber(this.entity.paced_activities);
            postData.assesment = this.pickNumber(this.entity.assesment);
            postData.break_time = this.pickNumber(this.entity.break_time);
            postData.total_time = this.pickNumber(this.entity.total_time);
            postData.price = this.pickFloat(this.entity.price);

            // Clean null keys
            let keys = Object.keys(postData);
            _.each(keys, key => {
                if (!postData[key] || postData[key] == null) delete postData[key];
            });

            if (postData.price && !_.isEmpty(postData.price)) {
                let floatPrice = parseFloat(postData.price);
                postData.price = parseInt(floatPrice*100.0);
            }

            if (this.entity.subcategories.length) {
                let subcatPks = _.map(this.entity.subcategories, elem => {
                    return `${elem.pk}`;
                });
                postData.subcategories = subcatPks.join(",");
            }

            Api.updateCec(postData, this.seed, this.$store.state.token).then(resp => {
                window.location.reload();
            }).catch()
        },
        addSubcategory(item) {
            this.entity.subcategories.push(_.pick(item, ...["category", "name", "pk"]));
        },
        removeSubcategory(item) {
            this.entity.subcategories = _.reject(this.entity.subcategories, element => {
                return (item.pk == element.pk);
            });
        }
    }
}

</script>

<style scoped lang="scss">
@import "./../../styles/common_forms";
@import "SchoolAdminCecs";
</style>



// WEBPACK FOOTER //
// src/components/school_admin_cecs/SchoolAdminCecs.vue